import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCallSkeleton = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 207 40" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle stroke="#919499" cx={20} cy={20} r={19.5} />
      <path
        d="m51.428 15.773 9.643-9.633m2.87 9.633 9.643-9.633m2.87 9.633 9.644-9.633m2.87 9.633 9.643-9.633m2.87 9.633 9.643-9.633m3.371 9.633 9.643-9.633m2.87 9.633 9.643-9.633m2.87 9.633 9.644-9.633m2.87 9.633 9.643-9.633"
        stroke="#919499"
      />
      <path fill="#919499" fillRule="nonzero" d="M51 33h156v1H51z" />
    </g>
  </svg>
);
const Memo = memo(SvgCallSkeleton);
export default Memo;
